/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Secrets
 * API for managing Secrets on Cloud Services.
 *
 * The version of the OpenAPI document: 2023-11-28
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SecretServiceBulkCreateAppKVSecretsBodyToJSON, SecretServiceCreateAppBodyToJSON, SecretServiceCreateAppKVSecretBodyToJSON, SecretServiceCreateAppRotatingSecretBodyToJSON, SecretServiceCreateAwsDynamicSecretBodyToJSON, SecretServiceCreateAwsIAMUserAccessKeyRotatingSecretBodyToJSON, SecretServiceCreateAwsIntegrationBodyToJSON, SecretServiceCreateAzureApplicationPasswordRotatingSecretBodyToJSON, SecretServiceCreateAzureIntegrationBodyToJSON, SecretServiceCreateConfluentCloudApiKeyRotatingSecretBodyToJSON, SecretServiceCreateConfluentIntegrationBodyToJSON, SecretServiceCreateGatewayPoolBodyToJSON, SecretServiceCreateGcpDynamicSecretBodyToJSON, SecretServiceCreateGcpIntegrationBodyToJSON, SecretServiceCreateGcpServiceAccountKeyRotatingSecretBodyToJSON, SecretServiceCreateIntegrationBodyToJSON, SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON, SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON, SecretServiceCreatePostgresIntegrationBodyToJSON, SecretServiceCreatePostgresRotatingSecretBodyToJSON, SecretServiceCreateRandomIntegrationBodyToJSON, SecretServiceCreateRandomRotatingSecretBodyToJSON, SecretServiceCreateSyncBodyToJSON, SecretServiceCreateTwilioIntegrationBodyToJSON, SecretServiceCreateTwilioRotatingSecretBodyToJSON, SecretServiceLockOrganizationBodyToJSON, SecretServiceLockProjectBodyToJSON, SecretServiceSetTierBodyToJSON, SecretServiceUpdateAppBodyToJSON, SecretServiceUpdateAppRotatingSecretBodyToJSON, SecretServiceUpdateAwsDynamicSecretBodyToJSON, SecretServiceUpdateAwsIAMUserAccessKeyRotatingSecretBodyToJSON, SecretServiceUpdateAwsIntegrationBodyToJSON, SecretServiceUpdateAzureApplicationPasswordRotatingSecretBodyToJSON, SecretServiceUpdateAzureIntegrationBodyToJSON, SecretServiceUpdateConfluentCloudApiKeyRotatingSecretBodyToJSON, SecretServiceUpdateConfluentIntegrationBodyToJSON, SecretServiceUpdateGatewayPoolBodyToJSON, SecretServiceUpdateGcpDynamicSecretBodyToJSON, SecretServiceUpdateGcpIntegrationBodyToJSON, SecretServiceUpdateGcpServiceAccountKeyRotatingSecretBodyToJSON, SecretServiceUpdateIntegrationBodyToJSON, SecretServiceUpdateMongoDBAtlasIntegrationBodyToJSON, SecretServiceUpdateMongoDBAtlasRotatingSecretBodyToJSON, SecretServiceUpdatePostgresIntegrationBodyToJSON, SecretServiceUpdatePostgresRotatingSecretBodyToJSON, SecretServiceUpdateRandomIntegrationBodyToJSON, SecretServiceUpdateRandomRotatingSecretBodyToJSON, SecretServiceUpdateTwilioIntegrationBodyToJSON, SecretServiceUpdateTwilioRotatingSecretBodyToJSON, Secrets20231128BulkCreateAppKVSecretsResponseFromJSON, Secrets20231128CreateAppKVSecretResponseFromJSON, Secrets20231128CreateAppResponseFromJSON, Secrets20231128CreateAppRotatingSecretResponseFromJSON, Secrets20231128CreateAwsDynamicSecretResponseFromJSON, Secrets20231128CreateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON, Secrets20231128CreateAwsIntegrationResponseFromJSON, Secrets20231128CreateAzureApplicationPasswordRotatingSecretResponseFromJSON, Secrets20231128CreateAzureIntegrationResponseFromJSON, Secrets20231128CreateConfluentCloudApiKeyRotatingSecretResponseFromJSON, Secrets20231128CreateConfluentIntegrationResponseFromJSON, Secrets20231128CreateGatewayPoolResponseFromJSON, Secrets20231128CreateGcpDynamicSecretResponseFromJSON, Secrets20231128CreateGcpIntegrationResponseFromJSON, Secrets20231128CreateGcpServiceAccountKeyRotatingSecretResponseFromJSON, Secrets20231128CreateIntegrationResponseFromJSON, Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON, Secrets20231128CreatePostgresIntegrationResponseFromJSON, Secrets20231128CreatePostgresRotatingSecretResponseFromJSON, Secrets20231128CreateRandomIntegrationResponseFromJSON, Secrets20231128CreateRandomRotatingSecretResponseFromJSON, Secrets20231128CreateSyncResponseFromJSON, Secrets20231128CreateTwilioIntegrationResponseFromJSON, Secrets20231128CreateTwilioRotatingSecretResponseFromJSON, Secrets20231128DescribeProviderResponseFromJSON, Secrets20231128GetAppResponseFromJSON, Secrets20231128GetAppRotatingSecretResponseFromJSON, Secrets20231128GetAppSecretResponseFromJSON, Secrets20231128GetAppSecretVersionResponseFromJSON, Secrets20231128GetAppSyncsResponseFromJSON, Secrets20231128GetAwsDynamicSecretResponseFromJSON, Secrets20231128GetAwsIAMUserAccessKeyRotatingSecretConfigResponseFromJSON, Secrets20231128GetAwsIntegrationResponseFromJSON, Secrets20231128GetAzureApplicationPasswordRotatingSecretConfigResponseFromJSON, Secrets20231128GetAzureIntegrationResponseFromJSON, Secrets20231128GetConfluentCloudApiKeyRotatingSecretConfigResponseFromJSON, Secrets20231128GetConfluentIntegrationResponseFromJSON, Secrets20231128GetGatewayPoolCertificateResponseFromJSON, Secrets20231128GetGatewayPoolResponseFromJSON, Secrets20231128GetGcpDynamicSecretResponseFromJSON, Secrets20231128GetGcpIntegrationResponseFromJSON, Secrets20231128GetGcpServiceAccountKeyRotatingSecretConfigResponseFromJSON, Secrets20231128GetIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON, Secrets20231128GetOrganizationLockStatusResponseFromJSON, Secrets20231128GetPostgresIntegrationResponseFromJSON, Secrets20231128GetPostgresRotatingSecretConfigResponseFromJSON, Secrets20231128GetProjectLockStatusResponseFromJSON, Secrets20231128GetRandomIntegrationResponseFromJSON, Secrets20231128GetRandomRotatingSecretConfigResponseFromJSON, Secrets20231128GetRotatingSecretStateResponseFromJSON, Secrets20231128GetSyncResponseFromJSON, Secrets20231128GetTwilioIntegrationResponseFromJSON, Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON, Secrets20231128GetUsageResponseFromJSON, Secrets20231128ListAppSecretVersionsResponseFromJSON, Secrets20231128ListAppSecretsResponseFromJSON, Secrets20231128ListAppsResponseFromJSON, Secrets20231128ListAwsDynamicSecretsResponseFromJSON, Secrets20231128ListAwsIntegrationsResponseFromJSON, Secrets20231128ListAzureIntegrationsResponseFromJSON, Secrets20231128ListConfluentIntegrationsResponseFromJSON, Secrets20231128ListGatewayPoolGatewaysResponseFromJSON, Secrets20231128ListGatewayPoolIntegrationsResponseFromJSON, Secrets20231128ListGatewayPoolsResponseFromJSON, Secrets20231128ListGcpDynamicSecretsResponseFromJSON, Secrets20231128ListGcpIntegrationsResponseFromJSON, Secrets20231128ListIntegrationsResponseFromJSON, Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON, Secrets20231128ListOpenAppSecretVersionsResponseFromJSON, Secrets20231128ListPostgresIntegrationsResponseFromJSON, Secrets20231128ListProvidersResponseFromJSON, Secrets20231128ListRandomIntegrationsResponseFromJSON, Secrets20231128ListSyncsResponseFromJSON, Secrets20231128ListTwilioIntegrationsResponseFromJSON, Secrets20231128OpenAppSecretResponseFromJSON, Secrets20231128OpenAppSecretVersionResponseFromJSON, Secrets20231128OpenAppSecretsResponseFromJSON, Secrets20231128UpdateAppResponseFromJSON, Secrets20231128UpdateAppRotatingSecretResponseFromJSON, Secrets20231128UpdateAwsDynamicSecretResponseFromJSON, Secrets20231128UpdateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON, Secrets20231128UpdateAwsIntegrationResponseFromJSON, Secrets20231128UpdateAzureApplicationPasswordRotatingSecretResponseFromJSON, Secrets20231128UpdateAzureIntegrationResponseFromJSON, Secrets20231128UpdateConfluentCloudApiKeyRotatingSecretResponseFromJSON, Secrets20231128UpdateConfluentIntegrationResponseFromJSON, Secrets20231128UpdateGatewayPoolResponseFromJSON, Secrets20231128UpdateGcpDynamicSecretResponseFromJSON, Secrets20231128UpdateGcpIntegrationResponseFromJSON, Secrets20231128UpdateGcpServiceAccountKeyRotatingSecretResponseFromJSON, Secrets20231128UpdateIntegrationResponseFromJSON, Secrets20231128UpdateMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128UpdateMongoDBAtlasRotatingSecretResponseFromJSON, Secrets20231128UpdatePostgresIntegrationResponseFromJSON, Secrets20231128UpdatePostgresRotatingSecretResponseFromJSON, Secrets20231128UpdateRandomIntegrationResponseFromJSON, Secrets20231128UpdateRandomRotatingSecretResponseFromJSON, Secrets20231128UpdateTwilioIntegrationResponseFromJSON, Secrets20231128UpdateTwilioRotatingSecretResponseFromJSON, } from '../models';
/**
 *
 */
export class SecretServiceApi extends runtime.BaseAPI {
    /**
     */
    async bulkCreateAppKVSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bulkCreateAppKVSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling bulkCreateAppKVSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling bulkCreateAppKVSecrets.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling bulkCreateAppKVSecrets.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secret/kv:batch`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceBulkCreateAppKVSecretsBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128BulkCreateAppKVSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async bulkCreateAppKVSecrets(organizationId, projectId, appName, body) {
        const response = await this.bulkCreateAppKVSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async createApp(organizationId, projectId, body) {
        const response = await this.createAppRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAppKVSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppKVSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secret/kv`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppKVSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppKVSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAppKVSecret(organizationId, projectId, appName, body) {
        const response = await this.createAppKVSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAppRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAppRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAppRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAppRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/rotating`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAppRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createAppRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsIAMUserAccessKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsIAMUserAccessKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsIAMUserAccessKeyRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createAwsIAMUserAccessKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsIntegration(organizationId, projectId, body) {
        const response = await this.createAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAzureApplicationPasswordRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAzureApplicationPasswordRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/azure/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAzureApplicationPasswordRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAzureApplicationPasswordRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAzureApplicationPasswordRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createAzureApplicationPasswordRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAzureIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAzureIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAzureIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAzureIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/azure/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAzureIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAzureIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAzureIntegration(organizationId, projectId, body) {
        const response = await this.createAzureIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createConfluentCloudApiKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createConfluentCloudApiKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/confluent/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateConfluentCloudApiKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateConfluentCloudApiKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createConfluentCloudApiKeyRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createConfluentCloudApiKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createConfluentIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createConfluentIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createConfluentIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createConfluentIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/confluent/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateConfluentIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateConfluentIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createConfluentIntegration(organizationId, projectId, body) {
        const response = await this.createConfluentIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGatewayPoolBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGatewayPool(organizationId, projectId, body) {
        const response = await this.createGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpIntegration(organizationId, projectId, body) {
        const response = await this.createGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpServiceAccountKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpServiceAccountKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpServiceAccountKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpServiceAccountKeyRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createGcpServiceAccountKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createIntegration(organizationId, projectId, body) {
        const response = await this.createIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasIntegration(organizationId, projectId, body) {
        const response = await this.createMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createMongoDBAtlasRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createPostgresIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createPostgresIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createPostgresIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createPostgresIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/postgres/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreatePostgresIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreatePostgresIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createPostgresIntegration(organizationId, projectId, body) {
        const response = await this.createPostgresIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createPostgresRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createPostgresRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createPostgresRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createPostgresRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createPostgresRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/postgres/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreatePostgresRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreatePostgresRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createPostgresRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createPostgresRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createRandomIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createRandomIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createRandomIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createRandomIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/random/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateRandomIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateRandomIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createRandomIntegration(organizationId, projectId, body) {
        const response = await this.createRandomIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createRandomRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createRandomRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createRandomRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createRandomRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createRandomRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/random/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateRandomRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateRandomRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createRandomRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createRandomRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createSyncRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createSync.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createSync.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createSync.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/syncs`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateSyncBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateSyncResponseFromJSON(jsonValue));
    }
    /**
     */
    async createSync(organizationId, projectId, body) {
        const response = await this.createSyncRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioIntegration(organizationId, projectId, body) {
        const response = await this.createTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createTwilioRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async deleteAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteApp(organizationId, projectId, name) {
        const response = await this.deleteAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.deleteAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.deleteAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async deleteAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsIntegration(organizationId, projectId, name) {
        const response = await this.deleteAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAzureIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAzureIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAzureIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAzureIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/azure/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAzureIntegration(organizationId, projectId, name) {
        const response = await this.deleteAzureIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteConfluentIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteConfluentIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteConfluentIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteConfluentIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/confluent/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteConfluentIntegration(organizationId, projectId, name) {
        const response = await this.deleteConfluentIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling deleteGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGatewayPool(organizationId, projectId, gatewayPoolName) {
        const response = await this.deleteGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async deleteGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpIntegration(organizationId, projectId, name) {
        const response = await this.deleteGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteIntegration(organizationId, projectId, name) {
        const response = await this.deleteIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteMongoDBAtlasIntegration(organizationId, projectId, name) {
        const response = await this.deleteMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deletePostgresIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deletePostgresIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deletePostgresIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deletePostgresIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/postgres/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deletePostgresIntegration(organizationId, projectId, name) {
        const response = await this.deletePostgresIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteRandomIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteRandomIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteRandomIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteRandomIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/random/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteRandomIntegration(organizationId, projectId, name) {
        const response = await this.deleteRandomIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteSyncRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteSync.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteSync.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteSync.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/syncs/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteSync(organizationId, projectId, name) {
        const response = await this.deleteSyncRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteTwilioIntegration(organizationId, projectId, name) {
        const response = await this.deleteTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async describeProviderRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling describeProvider.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling describeProvider.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling describeProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/providers/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128DescribeProviderResponseFromJSON(jsonValue));
    }
    /**
     */
    async describeProvider(organizationId, projectId, name) {
        const response = await this.describeProviderRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async getApp(organizationId, projectId, name) {
        const response = await this.getAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAppRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAppRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/rotating/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppRotatingSecret(organizationId, projectId, appName, name) {
        const response = await this.getAppRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.getAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.getAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     * PREVIEW / UNSTABLE
     */
    async getAppSyncsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSyncs.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSyncs.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAppSyncs.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}/syncs`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSyncsResponseFromJSON(jsonValue));
    }
    /**
     * PREVIEW / UNSTABLE
     */
    async getAppSyncs(organizationId, projectId, name) {
        const response = await this.getAppSyncsRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsIAMUserAccessKeyRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsIAMUserAccessKeyRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsIAMUserAccessKeyRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getAwsIAMUserAccessKeyRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsIntegration(organizationId, projectId, name) {
        const response = await this.getAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAzureApplicationPasswordRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAzureApplicationPasswordRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAzureApplicationPasswordRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAzureApplicationPasswordRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAzureApplicationPasswordRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/azure/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAzureApplicationPasswordRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAzureApplicationPasswordRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getAzureApplicationPasswordRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAzureIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAzureIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAzureIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAzureIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/azure/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAzureIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAzureIntegration(organizationId, projectId, name) {
        const response = await this.getAzureIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getConfluentCloudApiKeyRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getConfluentCloudApiKeyRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getConfluentCloudApiKeyRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getConfluentCloudApiKeyRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getConfluentCloudApiKeyRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/confluent/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetConfluentCloudApiKeyRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getConfluentCloudApiKeyRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getConfluentCloudApiKeyRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getConfluentIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getConfluentIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getConfluentIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getConfluentIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/confluent/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetConfluentIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getConfluentIntegration(organizationId, projectId, name) {
        const response = await this.getConfluentIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling getGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGatewayPool(organizationId, projectId, gatewayPoolName) {
        const response = await this.getGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async getGatewayPoolCertificateRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGatewayPoolCertificate.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGatewayPoolCertificate.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling getGatewayPoolCertificate.');
        }
        const queryParameters = {};
        if (requestParameters.csrPem !== undefined) {
            queryParameters['csr_pem'] = requestParameters.csrPem;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/certificate`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGatewayPoolCertificateResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGatewayPoolCertificate(organizationId, projectId, gatewayPoolName, csrPem) {
        const response = await this.getGatewayPoolCertificateRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName, csrPem: csrPem });
        return await response.value();
    }
    /**
     */
    async getGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpIntegration(organizationId, projectId, name) {
        const response = await this.getGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpServiceAccountKeyRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpServiceAccountKeyRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpServiceAccountKeyRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getGcpServiceAccountKeyRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getIntegration(organizationId, projectId, name) {
        const response = await this.getIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasIntegration(organizationId, projectId, name) {
        const response = await this.getMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getMongoDBAtlasRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getOrganizationLockStatusRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getOrganizationLockStatus.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/lock-status`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetOrganizationLockStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async getOrganizationLockStatus(organizationId) {
        const response = await this.getOrganizationLockStatusRaw({ organizationId: organizationId });
        return await response.value();
    }
    /**
     */
    async getPostgresIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPostgresIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getPostgresIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getPostgresIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/postgres/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetPostgresIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getPostgresIntegration(organizationId, projectId, name) {
        const response = await this.getPostgresIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getPostgresRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPostgresRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getPostgresRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getPostgresRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getPostgresRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/postgres/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetPostgresRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getPostgresRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getPostgresRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getProjectLockStatusRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getProjectLockStatus.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getProjectLockStatus.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/lock-status`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetProjectLockStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async getProjectLockStatus(organizationId, projectId) {
        const response = await this.getProjectLockStatusRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getRandomIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRandomIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getRandomIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getRandomIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/random/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetRandomIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getRandomIntegration(organizationId, projectId, name) {
        const response = await this.getRandomIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getRandomRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRandomRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getRandomRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getRandomRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getRandomRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/random/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetRandomRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getRandomRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getRandomRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getRotatingSecretStateRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getRotatingSecretState.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{name}/rotation-state`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetRotatingSecretStateResponseFromJSON(jsonValue));
    }
    /**
     */
    async getRotatingSecretState(organizationId, projectId, appName, name) {
        const response = await this.getRotatingSecretStateRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getSyncRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getSync.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getSync.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getSync.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/syncs/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetSyncResponseFromJSON(jsonValue));
    }
    /**
     */
    async getSync(organizationId, projectId, name) {
        const response = await this.getSyncRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioIntegration(organizationId, projectId, name) {
        const response = await this.getTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getTwilioRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getTwilioRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getUsageRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getUsage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage(organizationId, projectId) {
        const response = await this.getUsageRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getUsage2Raw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage2.');
        }
        const queryParameters = {};
        if (requestParameters.projectId !== undefined) {
            queryParameters['project_id'] = requestParameters.projectId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage2(organizationId, projectId) {
        const response = await this.getUsage2Raw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async listAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.nameContains !== undefined) {
            queryParameters['name_contains'] = requestParameters.nameContains;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, nameContains, types) {
        const response = await this.listAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, nameContains: nameContains, types: types });
        return await response.value();
    }
    /**
     */
    async listAppsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listApps.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listApps.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.nameContains !== undefined) {
            queryParameters['name_contains'] = requestParameters.nameContains;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listApps(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, nameContains) {
        const response = await this.listAppsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, nameContains: nameContains });
        return await response.value();
    }
    /**
     */
    async listAwsDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAwsDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAwsIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAzureIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAzureIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAzureIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/azure/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAzureIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAzureIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAzureIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listConfluentIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listConfluentIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listConfluentIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/confluent/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListConfluentIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listConfluentIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listConfluentIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolGatewaysRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPoolGateways.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPoolGateways.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling listGatewayPoolGateways.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/gateways`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolGatewaysResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPoolGateways(organizationId, projectId, gatewayPoolName) {
        const response = await this.listGatewayPoolGatewaysRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPoolIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPoolIntegrations.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling listGatewayPoolIntegrations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPoolIntegrations(organizationId, projectId, gatewayPoolName) {
        const response = await this.listGatewayPoolIntegrationsRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPools.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPools.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPools(organizationId, projectId) {
        const response = await this.listGatewayPoolsRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async listGcpDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listGcpDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGcpIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.capabilities) {
            queryParameters['capabilities'] = requestParameters.capabilities;
        }
        if (requestParameters.providers) {
            queryParameters['providers'] = requestParameters.providers;
        }
        if (requestParameters.nameContains !== undefined) {
            queryParameters['name_contains'] = requestParameters.nameContains;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, capabilities, providers, nameContains) {
        const response = await this.listIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, capabilities: capabilities, providers: providers, nameContains: nameContains });
        return await response.value();
    }
    /**
     */
    async listMongoDBAtlasIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listMongoDBAtlasIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listMongoDBAtlasIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listOpenAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listOpenAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListOpenAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listOpenAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listOpenAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listPostgresIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listPostgresIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listPostgresIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/postgres/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListPostgresIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listPostgresIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listPostgresIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listProvidersRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listProviders.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listProviders.');
        }
        const queryParameters = {};
        if (requestParameters.capabilities) {
            queryParameters['capabilities'] = requestParameters.capabilities;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/providers`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListProvidersResponseFromJSON(jsonValue));
    }
    /**
     */
    async listProviders(organizationId, projectId, capabilities) {
        const response = await this.listProvidersRaw({ organizationId: organizationId, projectId: projectId, capabilities: capabilities });
        return await response.value();
    }
    /**
     */
    async listRandomIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listRandomIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listRandomIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/random/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListRandomIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listRandomIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listRandomIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listSyncsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listSyncs.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listSyncs.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/syncs`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListSyncsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listSyncs(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listSyncsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listTwilioIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listTwilioIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listTwilioIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListTwilioIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listTwilioIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listTwilioIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async lockOrganizationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling lockOrganization.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling lockOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/lock`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceLockOrganizationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async lockOrganization(organizationId, body) {
        const response = await this.lockOrganizationRaw({ organizationId: organizationId, body: body });
        return await response.value();
    }
    /**
     */
    async lockProjectRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling lockProject.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling lockProject.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling lockProject.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/lock`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceLockProjectBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async lockProject(organizationId, projectId, body) {
        const response = await this.lockProjectRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async openAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.openAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async openAppSecretByResourceNameRaw(requestParameters) {
        if (requestParameters.resourceName === null || requestParameters.resourceName === undefined) {
            throw new runtime.RequiredError('resourceName', 'Required parameter requestParameters.resourceName was null or undefined when calling openAppSecretByResourceName.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/2023-11-28/{resource_name}:open`.replace(`{${"resource_name"}}`, encodeURIComponent(String(requestParameters.resourceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecretByResourceName(resourceName) {
        const response = await this.openAppSecretByResourceNameRaw({ resourceName: resourceName });
        return await response.value();
    }
    /**
     */
    async openAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling openAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.openAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async openAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        if (requestParameters.nameContains !== undefined) {
            queryParameters['name_contains'] = requestParameters.nameContains;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, types, nameContains) {
        const response = await this.openAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, types: types, nameContains: nameContains });
        return await response.value();
    }
    /**
     */
    async purgeAppAndSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling purgeAppAndSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling purgeAppAndSecrets.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling purgeAppAndSecrets.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}:purge`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async purgeAppAndSecrets(organizationId, projectId, name) {
        const response = await this.purgeAppAndSecretsRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async rotateSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling rotateSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{name}:rotate`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async rotateSecret(organizationId, projectId, appName, name, body) {
        const response = await this.rotateSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async setTierRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling setTier.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling setTier.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/billing/tier`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceSetTierBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async setTier(organizationId, body) {
        const response = await this.setTierRaw({ organizationId: organizationId, body: body });
        return await response.value();
    }
    /**
     */
    async unlockOrganizationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling unlockOrganization.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling unlockOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/unlock`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async unlockOrganization(organizationId, body) {
        const response = await this.unlockOrganizationRaw({ organizationId: organizationId, body: body });
        return await response.value();
    }
    /**
     */
    async unlockProjectRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling unlockProject.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling unlockProject.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling unlockProject.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/unlock`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async unlockProject(organizationId, projectId, body) {
        const response = await this.unlockProjectRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async updateAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateApp(organizationId, projectId, name, body) {
        const response = await this.updateAppRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAppRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAppRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAppRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAppRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAppRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAppRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/rotating/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAppRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAppRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAppRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAppRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsDynamicSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsIAMUserAccessKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsIAMUserAccessKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsIAMUserAccessKeyRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAwsIAMUserAccessKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsIntegration(organizationId, projectId, name, body) {
        const response = await this.updateAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAzureApplicationPasswordRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAzureApplicationPasswordRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAzureApplicationPasswordRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/azure/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAzureApplicationPasswordRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAzureApplicationPasswordRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAzureApplicationPasswordRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAzureApplicationPasswordRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAzureIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAzureIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAzureIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAzureIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAzureIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/azure/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAzureIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAzureIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAzureIntegration(organizationId, projectId, name, body) {
        const response = await this.updateAzureIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateConfluentCloudApiKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateConfluentCloudApiKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateConfluentCloudApiKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/confluent/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateConfluentCloudApiKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateConfluentCloudApiKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateConfluentCloudApiKeyRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateConfluentCloudApiKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateConfluentIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateConfluentIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateConfluentIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateConfluentIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateConfluentIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/confluent/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateConfluentIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateConfluentIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateConfluentIntegration(organizationId, projectId, name, body) {
        const response = await this.updateConfluentIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGatewayPoolBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGatewayPool(organizationId, projectId, gatewayPoolName, body) {
        const response = await this.updateGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpDynamicSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpIntegration(organizationId, projectId, name, body) {
        const response = await this.updateGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpServiceAccountKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpServiceAccountKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpServiceAccountKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpServiceAccountKeyRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateGcpServiceAccountKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateIntegration(organizationId, projectId, name, body) {
        const response = await this.updateIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateMongoDBAtlasIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateMongoDBAtlasIntegration(organizationId, projectId, name, body) {
        const response = await this.updateMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateMongoDBAtlasRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateMongoDBAtlasRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateMongoDBAtlasRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateMongoDBAtlasRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateMongoDBAtlasRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updatePostgresIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePostgresIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updatePostgresIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updatePostgresIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updatePostgresIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/postgres/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdatePostgresIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdatePostgresIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updatePostgresIntegration(organizationId, projectId, name, body) {
        const response = await this.updatePostgresIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updatePostgresRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePostgresRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updatePostgresRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updatePostgresRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updatePostgresRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updatePostgresRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/postgres/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdatePostgresRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdatePostgresRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updatePostgresRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updatePostgresRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateRandomIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateRandomIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateRandomIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateRandomIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateRandomIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/random/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateRandomIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateRandomIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateRandomIntegration(organizationId, projectId, name, body) {
        const response = await this.updateRandomIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateRandomRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateRandomRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateRandomRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateRandomRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateRandomRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateRandomRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/random/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateRandomRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateRandomRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateRandomRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateRandomRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateTwilioIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateTwilioIntegration(organizationId, projectId, name, body) {
        const response = await this.updateTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateTwilioRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateTwilioRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateTwilioRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateTwilioRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateTwilioRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateTwilioRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ListIntegrationsCapabilitiesEnum;
(function (ListIntegrationsCapabilitiesEnum) {
    ListIntegrationsCapabilitiesEnum["DYNAMIC"] = "DYNAMIC";
    ListIntegrationsCapabilitiesEnum["ROTATION"] = "ROTATION";
    ListIntegrationsCapabilitiesEnum["SYNC"] = "SYNC";
})(ListIntegrationsCapabilitiesEnum || (ListIntegrationsCapabilitiesEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var ListProvidersCapabilitiesEnum;
(function (ListProvidersCapabilitiesEnum) {
    ListProvidersCapabilitiesEnum["DYNAMIC"] = "DYNAMIC";
    ListProvidersCapabilitiesEnum["ROTATION"] = "ROTATION";
    ListProvidersCapabilitiesEnum["SYNC"] = "SYNC";
})(ListProvidersCapabilitiesEnum || (ListProvidersCapabilitiesEnum = {}));
